/** @graphql cc **/

import gql from 'graphql-tag';

export const MentionsProviderQuery = gql`
	query MentionsProviderQuery {
		entitlements {
			externalCollaborator {
				isEntitled
			}
		}
	}
`;
